import { Component, Input, Output, ViewChild  /*Output, EventEmitter*/ } from "@angular/core";

import { HttpService } from "../../providers/http.service";
// import * as moment from 'moment';
/**
 * Generated class for the DefaultTable component.
 *
 *
 */

@Component({
	selector: "default-table",
	templateUrl: "default-table.html",
	styleUrls: ["./default-table.scss"],
	providers: [],
})
export class DefaultTableComponent {

	/*
		- TODO:
			- CREATE SEARCH FUNCTIONALITY
			- CREATE TABLE TEMPLATE
			- CALLBACK FOR CHANGES ON PAGINATION

			options: {
				provider: // Server url for filter and list,
				headers: // Table headers for orderBy {"text","value"}
				template: // html template for form itens (users tableItens var for loop),
				perPage: //itens per page
			}
	*/

	@Input() options: any;
	@Output() refresh: any;
	search = "";
	sort: any;
	page = 0;
	total = 0;
	perPage = 10;
	pagination: any;
	itens: any;
	delay: any;
	paginationLimited = 0;
	additionalFilter: any;
	data: any;

	constructor(
		private httpService: HttpService
	) {
		console.log("Hello DefaultTableComponent Component");
		this.init();
	}

	init(): any {
		const self: any = this;
		// console.log(this.options);
		if (this.options) {
			const tempObj = {};
			if (this.options.name) {
				this.options.controller.defaultTable[this.options.name] = this;
			} else {
				this.options.controller.defaultTable = this;
			}
			// Array.isArray(this.options.controller.defaultTable) ?
			// this.options.controller.defaultTable.push(tempObj) : this.options.controller.defaultTable = this;
			this.getItens();
		} else {
			setTimeout(() => {
				self.init();
			}, 500);
		}
	}

	public getItens(sort: string = "", page: number = 0): any {
		console.log(page);
		console.log("options", this.options);
		const self: any = this;
		console.log(this.options.edit);
		// console.log('AAAAAAAAAAAAAAAAAAA',this.options.params.institutionId)
		this.options.getItens = this.getItens;
		if (this.options.params) {
			this.data = { _id: this.options.params.institutionId };
		} else {
			this.data = { find: this.search, page, sort, perPage: this.options.perPage };
		}
		this.httpService.post(this.options.url, true, this.data).then((res: any) => {
			console.log("RESSSSSSSS", res);
			if (res.items != null || res.itens != null) {
				if (res.items != null) {
					this.itens = res.items;
					console.log("items", this.itens);
				}
				if (res.itens != null) {
					this.itens = res.itens;
					console.log("itens", this.itens);
				}
				this.total = res.total;
				this.pagination = [];
				for (let i = 0; i <= Math.floor(this.total / this.options.perPage); i++) {
					this.pagination.push(i);
				}
			}
		})
			.catch(err => console.log(err));
	}

	orderSearch(value: any){
		let sort: any;
		if (this.sort !== value) {
			this.sort = value;
			sort = value;
		} else {
			this.sort = "";
			sort = "-" + value;
		}
		this.getItens(sort);
	}

	getValues(item: any, properties: string, pipe: string): any {

		let tempItem: any = item;
		const tempProperties: any = properties.split(".");
		// console.log('iiiiiiiiiiiiiiiiii',tempProperties)
		if (tempProperties.length < 1) {
			return "";
		}
		tempProperties.forEach(tp => {
			if (tempItem && tempItem.hasOwnProperty(tp)) {
				tempItem = tempItem[tp];
			} else {
				tempItem = "Não informado";
			}
		});
		if (pipe === "date") {
			// return moment(tempItem).format("DD/MM/YYYY");
		} else if (pipe === "images") {
			return tempItem ? "<img width='50' height='50' src='" + tempItem.host + tempItem.thumb + "'>" :
				"<img width='50' height='50' src='http://www.franzautomoveis.com.br/site/wp-content/plugins/jpro-cars/assets/img/no_image.jpg'>";
		} else {
			return tempItem;
		}
	}

	getItensBySearch(): any {
		clearTimeout(this.delay);
		this.delay = setTimeout(() => { this.getItens(); }, 1000);
		
	}

	reset(): any {
		this.search = "";
		this.getItens();
	}
}
